import {createBlocksModel} from '@wix/yoshi-flow-editor';

export default createBlocksModel({
  widgetName: 'errorMessageWidget',
  props: {
    text: {
      type: 'text',
      defaultValue: undefined,
    },
  },
  methods: {
    getTextSelector: {},
  },
  events: {},
});
